export default __webpack_public_path__ + "static/media/largeChalet.839d9790.svg";